<template>
  <div class="list-cards">
    <div v-for="card in optionsCards" :key="card.title">
      <task-options-card
        :title="card.title"
        :icon="card.icon"
        :action-for-get-data="card.actionForGetData"
        :action-for-update-data="card.actionForUpdateData"
        :init-data="card.initData"
        :limits-type="card.limitsType"/>
    </div>
  </div>
</template>

<script>
import TaskOptionsCard from '@/components/Pages/Tasks/TaskOptionsCard'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'TaskCostLimits',
  components: {
    TaskOptionsCard
  },
  computed: {
    ...mapGetters([
      'publishTasksCostLimits',
      'updateTasksCostLimits'
    ]),
    optionsCards() {
      return [
        {
          title: 'Лимиты задач на разработку',
          icon: { icon: 'Money', color: 'icon-primary' },
          actionForGetData: this.getTasksCostLimits,
          actionForUpdateData: this.editTasksCostLimits,
          initData: this.publishTasksCostLimits,
          limitsType: 'create'
        },
        {
          title: 'Лимиты задач на обновление',
          icon: { icon: 'Money', color: 'icon-warning' },
          actionForGetData: this.getTasksCostLimits,
          actionForUpdateData: this.editTasksCostLimits,
          initData: this.updateTasksCostLimits,
          limitsType: 'update'
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'getTasksCostLimits',
      'editTasksCostLimits'
    ])
  }
}
</script>

<style scoped>

</style>
